import { SetStateAction, useEffect, useState } from 'react'
import { TitleH1 } from '../../../Components/CustomUi/titleH1'
import PageContainer from '../../../Components/pageContainer'
import { TabelaComandos } from './components/tabela'
import { useGetComandos, useGetEditarComandos } from '../../../services/cadastroComandos/GET'

const CadastroComandos: React.FC = () => {

  //FORMULARIO
  const [openGaveta, setOpenGaveta] = useState<boolean>(false)
  const [update, setUpdate] = useState<number>(null)


  //TABELA
  const [buscarTabela, setBuscarTabela] = useState<string>('')
  const [pagination, setPagination] = useState<number>(15)
  const [page, setPage] = useState<number>(1)
  const [confirmar_exclusao, setConfirmar_exclusao] = useState<boolean>(false)
  const [id_item_atual, setId_item_atual] = useState<number>(null)
  const [nome_item_atual, setNome_item_atual] = useState<string>('')
  const [fake_loading, setFake_loading] = useState<boolean>(false)

  //API
  const { carregando_comandos, data_comandos, refetch_data_comandos } = useGetComandos(pagination, page, buscarTabela)
  const {carregando_comandos_editar, data_comandos_editar, refetch_data_comandos_editar} = useGetEditarComandos(update)

  function abrirGaveta() {
    setOpenGaveta(true)
  }

  function editar(cod) {
    setUpdate(cod)
    setOpenGaveta(true)
  }

  function fecharGaveta() {
    setUpdate(null)
    setOpenGaveta(false)
  }


  useEffect(() => {
    refetch_data_comandos()
  }, [])

  useEffect(() => {
    if (update > 0) {
      refetch_data_comandos_editar()
    }
  }, [update])

  return (
    <PageContainer>
      <TitleH1>Comandos</TitleH1>
      <TabelaComandos
        listar_comandos={data_comandos?.itens}
        carregando_cargos={carregando_comandos}
        total={data_comandos?.total}
        excluirCargo={undefined}
        confirmar_exclusao={confirmar_exclusao}
        buscarTabela={buscarTabela}
        abrir={abrirGaveta}
        setBuscarTabela={setBuscarTabela}
        editar={editar}
        setConfirmar_exclusao={setConfirmar_exclusao}
        id_item_atual={id_item_atual}
        setId_item_atual={setId_item_atual}
        nome_item_atual={nome_item_atual}
        setNome_item_atual={setNome_item_atual}
        fake_loading={fake_loading}
        setFake_loading={setFake_loading}
      />
    </PageContainer>
  )
}

export default CadastroComandos
